import { Link } from "react-router-dom";

interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  background: string;
  align?: "left" | "center";
  children?: React.ReactNode;
}

export default function PageHero({ eyebrow, title, description, background, align = "left", children }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src={background}
          alt={title}
          title={`${title} 星光传媒`}
          className="w-full h-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/10 via-transparent to-primary-950/40" />
      </div>
      <div className="relative z-10 px-4 md:px-6 pt-24 pb-12 md:pt-32 md:pb-16">
        <div className="max-w-[1440px] mx-auto">
          <div className={align === "center" ? "max-w-3xl mx-auto text-center" : "max-w-3xl"}>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm tracking-[0.22em] uppercase text-accent-300 mb-3 md:mb-4">
              <i className="ri-sparkling-2-line w-4 h-4 flex items-center justify-center"></i>
              {eyebrow}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 leading-tight mb-3 md:mb-4">
              {title}
            </h1>
            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-2xl mx-auto md:mx-0">
              {description}
            </p>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

export function Breadcrumb({ items }: { items: Array<{ label: string; to?: string }> }) {
  return (
    <nav className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300"></i>}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}